export const useStrapiUtils = () => {
  /** Populating in the context of the Strapi REST API means
   * including additional content with your response by returning more
   * fields than the ones returned by default. You use the populate parameter to achieve this.
   * https://docs.strapi.io/dev-docs/api/rest/guides/understanding-populate#detailed-population-strategy */

  const pageFieldsToPopulate = {
    populate: {
      components: {
        populate: "*",
      },
    },
  };
  const getComponent = (name: string) => {
    const emptyComponent = defineAsyncComponent(
      () => import("@/components/Strapi/Empty.vue")
    );
    const components: Record<string, any> = {
      "page.page-hero": defineAsyncComponent(
        () => import("@/components/Strapi/PageHero.vue")
      ),
      "page.join-widget": defineAsyncComponent(
        () => import("@/components/Strapi/JoinWidget.vue")
      ),
      "page.icon-grid": defineAsyncComponent(
        () => import("@/components/Strapi/IconGrid.vue")
      ),
      "page.plan-section": defineAsyncComponent(
        () => import("@/components/Strapi/PlanSection.vue")
      ),
      "page.image-text": defineAsyncComponent(
        () => import("@/components/Strapi/ImageText.vue")
      ),
      "page.app-banner": defineAsyncComponent(
        () => import("@/components/Strapi/AppBanner.vue")
      ),
      "page.rich-text": defineAsyncComponent(
        () => import("@/components/Strapi/RichText.vue")
      ),
      "page.cis-documents": defineAsyncComponent(
        () => import("@/components/Strapi/CisDocuments.vue")
      ),
      "page.accordion": defineAsyncComponent(
        () => import("@/components/Strapi/Accordions.vue")
      ),
      "page.image-content": defineAsyncComponent(
        () => import("@/components/Strapi/ImageContent.vue")
      ),
      "page.complaints-handling": defineAsyncComponent(
        () => import("@/components/Strapi/ComplaintsHandling.vue")
      ),
      "page.about-us": defineAsyncComponent(
        () => import("@/components/Strapi/AboutUs.vue")
      ),
      "page.network-coverage": defineAsyncComponent(
        () => import("@/components/Strapi/NetworkCoverage.vue")
      ),
      "page.outage-map": defineAsyncComponent(
        () => import("@/components/Strapi/OutageMap.vue")
      ),
      "page.faq-content": defineAsyncComponent(
        () => import("@/components/Strapi/FAQPage.vue")
      ),
      "page.simple-text": defineAsyncComponent(
        () => import("@/components/Strapi/SimpleText.vue")
      ),
      "page.roaming-rates": defineAsyncComponent(
        () => import("@/components/Strapi/RoamingRates.vue")
      ),
      // Extra-packs now has a dedicated page at /extra-packs
      // "page.extra-packs": defineAsyncComponent(
      //   () => import("@/components/Strapi/ExtraPacks.vue")
      // ),
      "page.hrt-authenticator": defineAsyncComponent(
        () => import("@/components/Strapi/HrtAuthentication.vue")
      ),
    };
    return components[name] || emptyComponent;
  };

  const getImageData = (image: any) => {
    if (!image || !image) {
      return null;
    }
    return image;
  };

  return { pageFieldsToPopulate, getComponent, getImageData };
};
